/* @generated from adl module totalinteraction.futurefit.db.learningevent */

import * as ADL from './../../../runtime/adl';
import * as common from './../../../common';

export interface LearningEvent_Registration {
  kind: 'registration';
  value: RegistrationEvent;
}
export interface LearningEvent_Confirmation {
  kind: 'confirmation';
  value: ConfirmationEvent;
}
export interface LearningEvent_Login {
  kind: 'login';
  value: LoginEvent;
}
export interface LearningEvent_View {
  kind: 'view';
  value: ViewEvent;
}
export interface LearningEvent_Commencement {
  kind: 'commencement';
  value: CommencementEvent;
}
export interface LearningEvent_Completion {
  kind: 'completion';
  value: CompletionEvent;
}

/**
 * Event types
 */
export type LearningEvent = LearningEvent_Registration | LearningEvent_Confirmation | LearningEvent_Login | LearningEvent_View | LearningEvent_Commencement | LearningEvent_Completion;

const LearningEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"registration","default":{"kind":"nothing"},"name":"registration","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"RegistrationEvent"}},"parameters":[]}},{"annotations":[],"serializedName":"confirmation","default":{"kind":"nothing"},"name":"confirmation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"ConfirmationEvent"}},"parameters":[]}},{"annotations":[],"serializedName":"login","default":{"kind":"nothing"},"name":"login","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"LoginEvent"}},"parameters":[]}},{"annotations":[],"serializedName":"view","default":{"kind":"nothing"},"name":"view","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"ViewEvent"}},"parameters":[]}},{"annotations":[],"serializedName":"commencement","default":{"kind":"nothing"},"name":"commencement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"CommencementEvent"}},"parameters":[]}},{"annotations":[],"serializedName":"completion","default":{"kind":"nothing"},"name":"completion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"CompletionEvent"}},"parameters":[]}}]}},"name":"LearningEvent","version":{"kind":"nothing"}}};

export const snLearningEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"LearningEvent"};

export function texprLearningEvent(): ADL.ATypeExpr<LearningEvent> {
  return {value : {typeRef : {kind: "reference", value : snLearningEvent}, parameters : []}};
}

/**
 * Defined (optional) properties - minimum required to link to skillseeker identifiers
 */
export interface EventOptionalProperties {
  firstname: string;
  lastname: string;
  email: string;
}

export function makeEventOptionalProperties(
  input: {
    firstname: string,
    lastname: string,
    email: string,
  }
): EventOptionalProperties {
  return {
    firstname: input.firstname,
    lastname: input.lastname,
    email: input.email,
  };
}

const EventOptionalProperties_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"firstname","default":{"kind":"nothing"},"name":"firstname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"lastname","default":{"kind":"nothing"},"name":"lastname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"EventOptionalProperties","version":{"kind":"nothing"}}};

export const snEventOptionalProperties: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"EventOptionalProperties"};

export function texprEventOptionalProperties(): ADL.ATypeExpr<EventOptionalProperties> {
  return {value : {typeRef : {kind: "reference", value : snEventOptionalProperties}, parameters : []}};
}

export interface EventFixedProperties {
  ip: string;
  distinct_id: string;
  host: string;
  username: string;
}

export function makeEventFixedProperties(
  input: {
    ip: string,
    distinct_id: string,
    host: string,
    username: string,
  }
): EventFixedProperties {
  return {
    ip: input.ip,
    distinct_id: input.distinct_id,
    host: input.host,
    username: input.username,
  };
}

const EventFixedProperties_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"ip","default":{"kind":"nothing"},"name":"ip","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"distinct_id","default":{"kind":"nothing"},"name":"distinct_id","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"username","default":{"kind":"nothing"},"name":"username","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"EventFixedProperties","version":{"kind":"nothing"}}};

export const snEventFixedProperties: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"EventFixedProperties"};

export function texprEventFixedProperties(): ADL.ATypeExpr<EventFixedProperties> {
  return {value : {typeRef : {kind: "reference", value : snEventFixedProperties}, parameters : []}};
}

export interface RegistrationEventProperties {
}

export function makeRegistrationEventProperties(
  _input: {
  }
): RegistrationEventProperties {
  return {
  };
}

const RegistrationEventProperties_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"RegistrationEventProperties","version":{"kind":"nothing"}}};

export const snRegistrationEventProperties: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"RegistrationEventProperties"};

export function texprRegistrationEventProperties(): ADL.ATypeExpr<RegistrationEventProperties> {
  return {value : {typeRef : {kind: "reference", value : snRegistrationEventProperties}, parameters : []}};
}

export enum LearningEventType {
  registration,
  confirmation,
  view,
  login,
  commencement,
  completion,
}

const LearningEventType_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"registration","default":{"kind":"nothing"},"name":"registration","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"confirmation","default":{"kind":"nothing"},"name":"confirmation","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"view","default":{"kind":"nothing"},"name":"view","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"login","default":{"kind":"nothing"},"name":"login","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"commencement","default":{"kind":"nothing"},"name":"commencement","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"completion","default":{"kind":"nothing"},"name":"completion","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"LearningEventType","version":{"kind":"nothing"}}};

export const snLearningEventType: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"LearningEventType"};

export function texprLearningEventType(): ADL.ATypeExpr<LearningEventType> {
  return {value : {typeRef : {kind: "reference", value : snLearningEventType}, parameters : []}};
}

export interface RegistrationEvent {
  event: string;
  properties: RegistrationEventProperties;
}

export function makeRegistrationEvent(
  input: {
    event?: string,
    properties: RegistrationEventProperties,
  }
): RegistrationEvent {
  return {
    event: input.event === undefined ? "registration" : input.event,
    properties: input.properties,
  };
}

const RegistrationEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"event","default":{"kind":"just","value":"registration"},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"properties","default":{"kind":"nothing"},"name":"properties","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"RegistrationEventProperties"}},"parameters":[]}}]}},"name":"RegistrationEvent","version":{"kind":"nothing"}}};

export const snRegistrationEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"RegistrationEvent"};

export function texprRegistrationEvent(): ADL.ATypeExpr<RegistrationEvent> {
  return {value : {typeRef : {kind: "reference", value : snRegistrationEvent}, parameters : []}};
}

export interface ConfirmationEventProperties {
}

export function makeConfirmationEventProperties(
  _input: {
  }
): ConfirmationEventProperties {
  return {
  };
}

const ConfirmationEventProperties_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"ConfirmationEventProperties","version":{"kind":"nothing"}}};

export const snConfirmationEventProperties: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"ConfirmationEventProperties"};

export function texprConfirmationEventProperties(): ADL.ATypeExpr<ConfirmationEventProperties> {
  return {value : {typeRef : {kind: "reference", value : snConfirmationEventProperties}, parameters : []}};
}

export interface ConfirmationEvent {
  event: string;
  properties: ConfirmationEventProperties;
}

export function makeConfirmationEvent(
  input: {
    event?: string,
    properties: ConfirmationEventProperties,
  }
): ConfirmationEvent {
  return {
    event: input.event === undefined ? "confirmation" : input.event,
    properties: input.properties,
  };
}

const ConfirmationEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"event","default":{"kind":"just","value":"confirmation"},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"properties","default":{"kind":"nothing"},"name":"properties","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"ConfirmationEventProperties"}},"parameters":[]}}]}},"name":"ConfirmationEvent","version":{"kind":"nothing"}}};

export const snConfirmationEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"ConfirmationEvent"};

export function texprConfirmationEvent(): ADL.ATypeExpr<ConfirmationEvent> {
  return {value : {typeRef : {kind: "reference", value : snConfirmationEvent}, parameters : []}};
}

/**
 * Event triggered on course view
 */
export interface ViewEventProperties {
  courseid: string;
  course: string;
  mode: string;
  ip: string;
  distinct_id: string;
  host: string;
  username: string;
  firstname: (string|null);
  lastname: (string|null);
  email: (string|null);
}

export function makeViewEventProperties(
  input: {
    courseid: string,
    course: string,
    mode: string,
    ip: string,
    distinct_id: string,
    host: string,
    username: string,
    firstname: (string|null),
    lastname: (string|null),
    email: (string|null),
  }
): ViewEventProperties {
  return {
    courseid: input.courseid,
    course: input.course,
    mode: input.mode,
    ip: input.ip,
    distinct_id: input.distinct_id,
    host: input.host,
    username: input.username,
    firstname: input.firstname,
    lastname: input.lastname,
    email: input.email,
  };
}

const ViewEventProperties_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"course","default":{"kind":"nothing"},"name":"course","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"mode","default":{"kind":"nothing"},"name":"mode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ip","default":{"kind":"nothing"},"name":"ip","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"distinct_id","default":{"kind":"nothing"},"name":"distinct_id","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"username","default":{"kind":"nothing"},"name":"username","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"firstname","default":{"kind":"nothing"},"name":"firstname","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"lastname","default":{"kind":"nothing"},"name":"lastname","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"ViewEventProperties","version":{"kind":"nothing"}}};

export const snViewEventProperties: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"ViewEventProperties"};

export function texprViewEventProperties(): ADL.ATypeExpr<ViewEventProperties> {
  return {value : {typeRef : {kind: "reference", value : snViewEventProperties}, parameters : []}};
}

export interface ViewEvent {
  event: string;
  properties: ViewEventProperties;
}

export function makeViewEvent(
  input: {
    event?: string,
    properties: ViewEventProperties,
  }
): ViewEvent {
  return {
    event: input.event === undefined ? "view" : input.event,
    properties: input.properties,
  };
}

const ViewEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"event","default":{"kind":"just","value":"view"},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"properties","default":{"kind":"nothing"},"name":"properties","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"ViewEventProperties"}},"parameters":[]}}]}},"name":"ViewEvent","version":{"kind":"nothing"}}};

export const snViewEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"ViewEvent"};

export function texprViewEvent(): ADL.ATypeExpr<ViewEvent> {
  return {value : {typeRef : {kind: "reference", value : snViewEvent}, parameters : []}};
}

export enum ViewEventMode {
  normal,
  preview,
  review,
}

const ViewEventMode_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"normal","default":{"kind":"nothing"},"name":"normal","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"preview","default":{"kind":"nothing"},"name":"preview","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"review","default":{"kind":"nothing"},"name":"review","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"ViewEventMode","version":{"kind":"nothing"}}};

export const snViewEventMode: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"ViewEventMode"};

export function texprViewEventMode(): ADL.ATypeExpr<ViewEventMode> {
  return {value : {typeRef : {kind: "reference", value : snViewEventMode}, parameters : []}};
}

export interface LoginEventProperties {
  browser: string;
  version: string;
  platform: string;
  device: string;
  ip: string;
  distinct_id: string;
  host: string;
  username: string;
  firstname: (string|null);
  lastname: (string|null);
  email: (string|null);
}

export function makeLoginEventProperties(
  input: {
    browser: string,
    version: string,
    platform: string,
    device: string,
    ip: string,
    distinct_id: string,
    host: string,
    username: string,
    firstname: (string|null),
    lastname: (string|null),
    email: (string|null),
  }
): LoginEventProperties {
  return {
    browser: input.browser,
    version: input.version,
    platform: input.platform,
    device: input.device,
    ip: input.ip,
    distinct_id: input.distinct_id,
    host: input.host,
    username: input.username,
    firstname: input.firstname,
    lastname: input.lastname,
    email: input.email,
  };
}

const LoginEventProperties_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"browser","default":{"kind":"nothing"},"name":"browser","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"platform","default":{"kind":"nothing"},"name":"platform","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"device","default":{"kind":"nothing"},"name":"device","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ip","default":{"kind":"nothing"},"name":"ip","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"distinct_id","default":{"kind":"nothing"},"name":"distinct_id","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"username","default":{"kind":"nothing"},"name":"username","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"firstname","default":{"kind":"nothing"},"name":"firstname","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"lastname","default":{"kind":"nothing"},"name":"lastname","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"LoginEventProperties","version":{"kind":"nothing"}}};

export const snLoginEventProperties: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"LoginEventProperties"};

export function texprLoginEventProperties(): ADL.ATypeExpr<LoginEventProperties> {
  return {value : {typeRef : {kind: "reference", value : snLoginEventProperties}, parameters : []}};
}

export interface LoginEvent {
  event: string;
  properties: LoginEventProperties;
}

export function makeLoginEvent(
  input: {
    event?: string,
    properties: LoginEventProperties,
  }
): LoginEvent {
  return {
    event: input.event === undefined ? "login" : input.event,
    properties: input.properties,
  };
}

const LoginEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"event","default":{"kind":"just","value":"login"},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"properties","default":{"kind":"nothing"},"name":"properties","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"LoginEventProperties"}},"parameters":[]}}]}},"name":"LoginEvent","version":{"kind":"nothing"}}};

export const snLoginEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"LoginEvent"};

export function texprLoginEvent(): ADL.ATypeExpr<LoginEvent> {
  return {value : {typeRef : {kind: "reference", value : snLoginEvent}, parameters : []}};
}

/**
 * Event triggered on starting a course
 */
export interface CommencementEventProperties {
  courseid: string;
  course: string;
  attempt: number;
  ip: string;
  distinct_id: string;
  host: string;
  username: string;
  firstname: (string|null);
  lastname: (string|null);
  email: (string|null);
}

export function makeCommencementEventProperties(
  input: {
    courseid: string,
    course: string,
    attempt: number,
    ip: string,
    distinct_id: string,
    host: string,
    username: string,
    firstname: (string|null),
    lastname: (string|null),
    email: (string|null),
  }
): CommencementEventProperties {
  return {
    courseid: input.courseid,
    course: input.course,
    attempt: input.attempt,
    ip: input.ip,
    distinct_id: input.distinct_id,
    host: input.host,
    username: input.username,
    firstname: input.firstname,
    lastname: input.lastname,
    email: input.email,
  };
}

const CommencementEventProperties_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"course","default":{"kind":"nothing"},"name":"course","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"attempt","default":{"kind":"nothing"},"name":"attempt","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"ip","default":{"kind":"nothing"},"name":"ip","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"distinct_id","default":{"kind":"nothing"},"name":"distinct_id","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"username","default":{"kind":"nothing"},"name":"username","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"firstname","default":{"kind":"nothing"},"name":"firstname","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"lastname","default":{"kind":"nothing"},"name":"lastname","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"CommencementEventProperties","version":{"kind":"nothing"}}};

export const snCommencementEventProperties: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"CommencementEventProperties"};

export function texprCommencementEventProperties(): ADL.ATypeExpr<CommencementEventProperties> {
  return {value : {typeRef : {kind: "reference", value : snCommencementEventProperties}, parameters : []}};
}

export interface CommencementEvent {
  event: string;
  properties: CommencementEventProperties;
}

export function makeCommencementEvent(
  input: {
    event?: string,
    properties: CommencementEventProperties,
  }
): CommencementEvent {
  return {
    event: input.event === undefined ? "commencement" : input.event,
    properties: input.properties,
  };
}

const CommencementEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"event","default":{"kind":"just","value":"commencement"},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"properties","default":{"kind":"nothing"},"name":"properties","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"CommencementEventProperties"}},"parameters":[]}}]}},"name":"CommencementEvent","version":{"kind":"nothing"}}};

export const snCommencementEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"CommencementEvent"};

export function texprCommencementEvent(): ADL.ATypeExpr<CommencementEvent> {
  return {value : {typeRef : {kind: "reference", value : snCommencementEvent}, parameters : []}};
}

/**
 * Event triggered on completing a course
 */
export interface CompletionEventProperties {
  courseid: string;
  course: string;
  attempt: number;
  status: string;
  trackid: string;
  ip: string;
  distinct_id: string;
  host: string;
  username: string;
  firstname: (string|null);
  lastname: (string|null);
  email: (string|null);
}

export function makeCompletionEventProperties(
  input: {
    courseid: string,
    course: string,
    attempt: number,
    status: string,
    trackid: string,
    ip: string,
    distinct_id: string,
    host: string,
    username: string,
    firstname: (string|null),
    lastname: (string|null),
    email: (string|null),
  }
): CompletionEventProperties {
  return {
    courseid: input.courseid,
    course: input.course,
    attempt: input.attempt,
    status: input.status,
    trackid: input.trackid,
    ip: input.ip,
    distinct_id: input.distinct_id,
    host: input.host,
    username: input.username,
    firstname: input.firstname,
    lastname: input.lastname,
    email: input.email,
  };
}

const CompletionEventProperties_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"courseid","default":{"kind":"nothing"},"name":"courseid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"course","default":{"kind":"nothing"},"name":"course","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"attempt","default":{"kind":"nothing"},"name":"attempt","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"trackid","default":{"kind":"nothing"},"name":"trackid","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ip","default":{"kind":"nothing"},"name":"ip","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"distinct_id","default":{"kind":"nothing"},"name":"distinct_id","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"host","default":{"kind":"nothing"},"name":"host","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"username","default":{"kind":"nothing"},"name":"username","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"firstname","default":{"kind":"nothing"},"name":"firstname","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"lastname","default":{"kind":"nothing"},"name":"lastname","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"CompletionEventProperties","version":{"kind":"nothing"}}};

export const snCompletionEventProperties: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"CompletionEventProperties"};

export function texprCompletionEventProperties(): ADL.ATypeExpr<CompletionEventProperties> {
  return {value : {typeRef : {kind: "reference", value : snCompletionEventProperties}, parameters : []}};
}

export interface CompletionEvent {
  event: string;
  properties: CompletionEventProperties;
}

export function makeCompletionEvent(
  input: {
    event?: string,
    properties: CompletionEventProperties,
  }
): CompletionEvent {
  return {
    event: input.event === undefined ? "completion" : input.event,
    properties: input.properties,
  };
}

const CompletionEvent_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"event","default":{"kind":"just","value":"completion"},"name":"event","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"properties","default":{"kind":"nothing"},"name":"properties","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"CompletionEventProperties"}},"parameters":[]}}]}},"name":"CompletionEvent","version":{"kind":"nothing"}}};

export const snCompletionEvent: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"CompletionEvent"};

export function texprCompletionEvent(): ADL.ATypeExpr<CompletionEvent> {
  return {value : {typeRef : {kind: "reference", value : snCompletionEvent}, parameters : []}};
}

export enum CompletionStatus {
  passed,
  failed,
  completed,
}

const CompletionStatus_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"passed","default":{"kind":"nothing"},"name":"passed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"failed","default":{"kind":"nothing"},"name":"failed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"completed","default":{"kind":"nothing"},"name":"completed","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CompletionStatus","version":{"kind":"nothing"}}};

export const snCompletionStatus: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"CompletionStatus"};

export function texprCompletionStatus(): ADL.ATypeExpr<CompletionStatus> {
  return {value : {typeRef : {kind: "reference", value : snCompletionStatus}, parameters : []}};
}

/**
 * Log table for events captured
 */
export interface ScodleEventLog {
  /**
   * Capture time
   */
  logTime: common.Instant;
  /**
   * Raw event as captured
   */
  inputEvent: string;
  /**
   * Translated event
   */
  event: LearningEvent;
}

export function makeScodleEventLog(
  input: {
    logTime: common.Instant,
    inputEvent: string,
    event: LearningEvent,
  }
): ScodleEventLog {
  return {
    logTime: input.logTime,
    inputEvent: input.inputEvent,
    event: input.event,
  };
}

const ScodleEventLog_AST : ADL.ScopedDecl =
  {"moduleName":"totalinteraction.futurefit.db.learningevent","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"logTime","default":{"kind":"nothing"},"name":"logTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"inputEvent","default":{"kind":"nothing"},"name":"inputEvent","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"event","default":{"kind":"nothing"},"name":"event","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"totalinteraction.futurefit.db.learningevent","name":"LearningEvent"}},"parameters":[]}}]}},"name":"ScodleEventLog","version":{"kind":"nothing"}}};

export const snScodleEventLog: ADL.ScopedName = {moduleName:"totalinteraction.futurefit.db.learningevent", name:"ScodleEventLog"};

export function texprScodleEventLog(): ADL.ATypeExpr<ScodleEventLog> {
  return {value : {typeRef : {kind: "reference", value : snScodleEventLog}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "totalinteraction.futurefit.db.learningevent.LearningEvent" : LearningEvent_AST,
  "totalinteraction.futurefit.db.learningevent.EventOptionalProperties" : EventOptionalProperties_AST,
  "totalinteraction.futurefit.db.learningevent.EventFixedProperties" : EventFixedProperties_AST,
  "totalinteraction.futurefit.db.learningevent.RegistrationEventProperties" : RegistrationEventProperties_AST,
  "totalinteraction.futurefit.db.learningevent.LearningEventType" : LearningEventType_AST,
  "totalinteraction.futurefit.db.learningevent.RegistrationEvent" : RegistrationEvent_AST,
  "totalinteraction.futurefit.db.learningevent.ConfirmationEventProperties" : ConfirmationEventProperties_AST,
  "totalinteraction.futurefit.db.learningevent.ConfirmationEvent" : ConfirmationEvent_AST,
  "totalinteraction.futurefit.db.learningevent.ViewEventProperties" : ViewEventProperties_AST,
  "totalinteraction.futurefit.db.learningevent.ViewEvent" : ViewEvent_AST,
  "totalinteraction.futurefit.db.learningevent.ViewEventMode" : ViewEventMode_AST,
  "totalinteraction.futurefit.db.learningevent.LoginEventProperties" : LoginEventProperties_AST,
  "totalinteraction.futurefit.db.learningevent.LoginEvent" : LoginEvent_AST,
  "totalinteraction.futurefit.db.learningevent.CommencementEventProperties" : CommencementEventProperties_AST,
  "totalinteraction.futurefit.db.learningevent.CommencementEvent" : CommencementEvent_AST,
  "totalinteraction.futurefit.db.learningevent.CompletionEventProperties" : CompletionEventProperties_AST,
  "totalinteraction.futurefit.db.learningevent.CompletionEvent" : CompletionEvent_AST,
  "totalinteraction.futurefit.db.learningevent.CompletionStatus" : CompletionStatus_AST,
  "totalinteraction.futurefit.db.learningevent.ScodleEventLog" : ScodleEventLog_AST
};



// WEBPACK FOOTER //
// ./src/adl-gen/totalinteraction/futurefit/db/learningevent.ts